import ScrollReveal from "@/components/feature/ScrollReveal";

const capabilities = [
  {
    icon: "ri-server-line",
    title: "Infrastructure & Cloud",
    desc: "Multi-cloud architecture, hybrid setups, and on-premise modernization with 99.9% uptime SLAs.",
  },
  {
    icon: "ri-phone-line",
    title: "VOIP & Communications",
    desc: "Enterprise-grade voice, video, and unified communications deployed securely across locations.",
  },
  {
    icon: "ri-government-line",
    title: "IT Governance & Compliance",
    desc: "Policy frameworks, risk assessments, and regulatory alignment including GDPR and HIPAA readiness.",
  },
];

export default function InfrastructureSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-white dark:bg-dark-bg">
      <div className="px-4 md:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-3 py-1 rounded-full bg-brand-50 dark:bg-brand-500/10 text-brand-600 dark:text-brand-400 text-xs font-semibold uppercase tracking-wider mb-4">
              Beyond the Basics
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3">
              Infrastructure, VOIP &amp; Governance
            </h2>
            <p className="text-sm md:text-base text-gray-500 dark:text-gray-400 max-w-xl mx-auto">
              We handle the full stack - from cabling to cloud governance.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {capabilities.map((c, i) => (
            <ScrollReveal key={c.title} delay={i + 1}>
              <div className="group p-6 md:p-8 rounded-2xl bg-gray-50 dark:bg-dark-card border border-gray-100 dark:border-dark-border hover:border-brand-200 dark:hover:border-brand-500/30 transition-all duration-300">
                <div className="w-12 h-12 rounded-xl bg-brand-50 dark:bg-brand-500/10 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${c.icon} text-xl text-brand-500`} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                  {c.title}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                  {c.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}